import React, { useState, useEffect } from "react";
import {
  Table,
  Card,
  Badge,
  Button,
  Spinner,
  Form,
  InputGroup,
} from "react-bootstrap";
import { useAuth } from "../../hooks/useAuth";

const PartnerCustomer = ({ partnerId }) => {
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const { backendUrl, token } = useAuth();

  useEffect(() => {
    const fetchCustomers = async () => {
      try {
        setLoading(true);
        const response = await fetch(
          `${backendUrl}/api/partnership/customers/${partnerId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );

        if (!response.ok) {
          throw new Error("Failed to fetch customers");
        }

        const [data] = await response.json();
        console.log(data);
        setCustomers(data.customers || []);
      } catch (err) {
        setError(err.message);
        console.error("Error fetching customers:", err);
      } finally {
        setLoading(false);
      }
    };

    if (partnerId) {
      fetchCustomers();
    }
  }, [partnerId, backendUrl, token]);

  const filteredCustomers = customers.filter(
    (customer) =>
      customer.company_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      customer.contact_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      customer.contact_email
        ?.toLowerCase()
        .includes(searchTerm.toLowerCase()) ||
      customer.city?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      customer.country?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleViewDetails = (customerId) => {
    // Implement view details functionality
    console.log("View details for customer:", customerId);
  };

  if (loading) {
    return (
      <div className="text-center my-5">
        <Spinner animation="border" variant="primary" />
        <p className="mt-2">Loading customers...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="alert alert-danger" role="alert">
        Error: {error}
      </div>
    );
  }

  return (
    <div className="container-fluid">
      <InputGroup className="w-50 mb-8" style={{ justifySelf: "end" }}>
        <Form.Control
          placeholder="Search customers..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
        {searchTerm && (
          <Button variant="outline-secondary" onClick={() => setSearchTerm("")}>
            Clear
          </Button>
        )}
      </InputGroup>
      <Card className=" mb-4">
        {/* <Card.Header className="bg-light">
          <div className="d-flex justify-content-between align-items-center">
            <h5 className="mb-0">Partner Customers</h5>
            
          </div>
        </Card.Header> */}
        <Card.Body>
          {filteredCustomers.length === 0 ? (
            <div className="text-center py-5">
              <p className="text-muted">No customers found</p>
            </div>
          ) : (
            <div className="table-responsive">
              <Table hover className="align-middle">
                <thead>
                  <tr>
                    <th>Company Name</th>
                    <th>Contact Person</th>
                    <th>Contact Info</th>
                    <th>Location</th>
                    <th>Created</th>
                    {/* <th>Actions</th> */}
                  </tr>
                </thead>
                <tbody>
                  {filteredCustomers.map((customer) => (
                    <tr key={customer.id}>
                      <td>
                        <div className="fw-bold">{customer.company_name}</div>
                        <div className="small text-muted">
                          ID: {customer.partnership_id}
                        </div>
                      </td>
                      <td>{customer.contact_name || "—"}</td>
                      <td>
                        <div>{customer.contact_email || "—"}</div>
                        <div>{customer.contact_phone || "—"}</div>
                      </td>
                      <td>
                        <div>
                          {customer.city}
                          {customer.city && customer.country ? ", " : ""}
                          {customer.country}
                        </div>
                        <div className="small text-muted">
                          {customer.postal_code
                            ? `${customer.postal_code}, `
                            : ""}
                          {customer.state_province || ""}
                        </div>
                      </td>
                      <td>
                        {customer.created_at
                          ? new Date(customer.created_at).toLocaleDateString()
                          : "—"}
                      </td>
                      {/* <td>
                        <Button
                          variant="outline-primary"
                          size="sm"
                          onClick={() => handleViewDetails(customer.id)}
                        >
                          View Details
                        </Button>
                      </td> */}
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          )}
        </Card.Body>
        <Card.Footer className="">
          <div className="d-flex justify-content-between align-items-center">
            <span className="text-muted">
              Showing {filteredCustomers.length} of {customers.length} customers
            </span>
          </div>
        </Card.Footer>
      </Card>
    </div>
  );
};

export default PartnerCustomer;
